import { parseCookies } from 'nookies'

// SC-11817: avisos `dismissible` (ex.: pesquisa de NPS) podem ser fechados, e só
// voltam no dia seguinte. A marca fica no navegador, por usuário e por tipo de aviso.
const STORAGE_PREFIX = 'account_alert_dismissed'

export const ACCOUNT_ALERTS_CHANGED = 'account-alerts:changed'

const todayKey = () => {
  const now = new Date()
  return `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`
}

const storageKey = (type: string) => {
  const { ['nextauth.merchant_user_uuid']: userUuid } = parseCookies()
  return `${STORAGE_PREFIX}:${userUuid || 'anon'}:${type}`
}

export const isAlertDismissedToday = (type: string) => {
  try {
    return localStorage.getItem(storageKey(type)) === todayKey()
  } catch {
    return false
  }
}

// Avisa o banner para recarregar (ex.: a pesquisa foi respondida e a API deixa
// de devolver o aviso).
export const notifyAccountAlertsChanged = () => {
  window.dispatchEvent(new Event(ACCOUNT_ALERTS_CHANGED))
}

export const dismissAlertForToday = (type: string) => {
  try {
    localStorage.setItem(storageKey(type), todayKey())
  } catch {
    // Sem storage o aviso só some até a próxima página; nada a fazer.
  }
  notifyAccountAlertsChanged()
}
